import { createMuiTheme } from "@material-ui/core/styles";
import { alti } from "./stylingVariables";

export const theme = createMuiTheme({
  overrides: {
    MuiExpansionPanel: {
      root: {
        "&.Mui-expanded": {
          margin: "0",
        },
        "&:before": {
          backgroundColor: "none",
        },
      },
    },
    MuiDrawer: {
      paperAnchorDockedLeft: {
        borderRight: "none",
      },
    },
    MuiIcon: {
      root: {
        width: "1.3em",
        height: "1.3em",
        overflow: "hidden",
        fontSize: "1.2rem",
        flexShrink: "1",
        userSelect: "none",
      },
    },
    MuiTouchRipple: {
      root: {
        display: "none",
      },
    },
    MuiPaper: {
      root: {
        boxShadow: "none !important",
      },
    },
    MuiTooltip: {
      tooltip: {
        maxWidth: "210px",
        "@media (min-width: 600px)": {
          maxWidth: "300px",
        },
      },
      tooltipArrow: {
        fontSize: "1.2em",
        backgroundColor: "#333",
        color: "rgba(241, 241, 241, 0.87)",
        padding: "8px",
        textShadow: "1px 1px 2px #000",
      },
      arrow: {
        color: "#333",
      },
    },
    MuiIconButton: {
      colorSecondary: {
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0.0) !important",
        },
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        color: `${alti.couleurSecondaire} !important`,
        "&$checked": {
          "&:hover": {
            backgroundColor: "rgba(8,62,102, 0.0) !important",
          },
        },
      },
    },
    MuiSwitch: {
      switchBase: {
        color: `${alti.couleurSecondaire} !important`,
        "&$checked": {
          color: `${alti.couleurSecondaire} !important`,
        },
        "&$checked + $track": {
          backgroundColor: `${alti.couleurSecondaire} !important`,
        },
      },
      checked: {},
      track: {},
    },
    MuiSvgIcon: {
      colorSecondary: {
        color: `${alti.couleurSecondaire} !important`,
      },
      fontSizeLarge: {
        fontSize: "2rem",
      },
    },
  },
});

export const ButtonClose = createMuiTheme({
  overrides: {
    MuiButton: {
      root: {
        minWidth: "auto",
      },
      startIcon: {
        marginLeft: "0",
        marginRight: "0",
      },
      text: {
        padding: "6px",
      },
    },
  },
});

export const ButtonTheme = createMuiTheme({
  overrides: {
    MuiButton: {
      text: {
        padding: "6px 30px",
        whiteSpace: "nowrap",
      },
    },
  },
});

export const CheckboxTheme = createMuiTheme({
  overrides: {
    PrivateSwitchBase: {
      root: {
        padding: "5px",
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        color: `${alti.couleurSecondaire} !important`,
        "&:hover": {
          backgroundColor: "rgba(8,	62,	102, 0.04) !important",
        },
      },
    },
  },
});

export const DrawerEligibiliteSearchTheme = createMuiTheme({
  overrides: {
    MuiDrawer: {
      paperAnchorLeft: {
        minWidth: "320px",
        width: "100%",
        zIndex: 1000,
        boxSizing: "border-box",
      },
    },
    MuiFormControl: {
      root: {
        width: "100%",
      },
    },
  },
});

export const DrawerEligibiliteSearchThemeClosed = createMuiTheme({
  overrides: {
    MuiDrawer: {
      paperAnchorLeft: {
        width: "550px",
      },
    },
  },
});

export const MenuIconsTheme = createMuiTheme({
  overrides: {
    MuiSvgIcon: {
      fontSizeLarge: {
        fontSize: "2rem",
      },
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: "#FFFFFF",
        color: "rgba(0, 0, 0, 0.87)",
      },
      tooltipArrow: {
        fontSize: "1.2em",
        backgroundColor: "#FFFFFF",
        color: "rgba(0, 0, 0, 0.87)",
        padding: "10px",
      },
      arrow: {
        color: "#FFFFFF",
      },
    },
  },
});
